import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueSimpleAlert from "vue-simple-alert";




Vue.config.productionTip = false
Vue.config.silent = true // Deshabilitar para hacer QA.

Vue.use(VueSimpleAlert);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
